import { render, staticRenderFns } from "./manageEkrm.vue?vue&type=template&id=8ddadae2&"
import script from "./manageEkrm.vue?vue&type=script&lang=js&"
export * from "./manageEkrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports